import { isChrome, isEdge, isChromium, isOpera } from 'react-device-detect';

import { Fragment, useState } from 'react';
import { Transition } from '@headlessui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

import {
  faTimes,
  faExclamationTriangle,
} from '@fortawesome/pro-light-svg-icons';

export const BroswerDetect = () => {
  const [show, setShow] = useState(!(isChrome || isEdge || isOpera));
  const { t } = useTranslation();
  return (
    <>
      {/* Global notification live region, render this permanently at the end of the document */}
      <div
        aria-live="assertive"
        className="fixed inset-0 flex  px-4 py-6 pointer-events-none sm:pt-12 md:items-start z-20 "
      >
        <div className="w-full flex flex-col items-center space-y-4 sm:items-end px-16 py-24 md:py-12">
          {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
          <Transition
            show={show}
            as={Fragment}
            enter="transform ease-out duration-500 transition"
            enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
            enterTo="translate-y-0 opacity-100 sm:translate-x-0"
            leave="transition ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="max-w-3xl w-full bg-gray-50 shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidde">
              <div className="p-4">
                <div className="flex items-start">
                  <div className="p-6 text-2xl sm:text-lg ">
                    <FontAwesomeIcon icon={faExclamationTriangle} size="2x" />
                  </div>
                  {/* <div className="flex-shrink-0" /> */}
                  <div className="ml-3 w-0 flex-1 pt-0.5">
                    <p className="text-sm font-medium text-gray-900">
                      {t('BROWSER_SUPPORT.NOTIFICATION_MSSG.NOTICED')}
                    </p>
                    <p className="mt-1 text-sm text-gray-600">
                      {t(
                        'BROWSER_SUPPORT.NOTIFICATION_MSSG.RECOMENDATION_PART_1'
                      )}
                      <a
                        className="text-blue-500"
                        href="https://www.google.com/chrome/"
                      >
                        Chrome
                      </a>
                      {t('BROWSER_SUPPORT.NOTIFICATION_MSSG.OR')}
                      <a
                        className="text-blue-500"
                        href="https://www.microsoft.com/edge"
                      >
                        Edge
                      </a>
                      {t(
                        'BROWSER_SUPPORT.NOTIFICATION_MSSG.RECOMENDATION_PART_2'
                      )}
                    </p>
                  </div>
                  <div className="ml-4 flex-shrink-0 flex">
                    <button
                      type="button"
                      className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                      onClick={() => {
                        setShow(false);
                      }}
                    >
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Transition>
        </div>
      </div>
    </>
  );
};
